module.exports = __webpack_public_path__ + "logo.gif?54752b3307ea3bb41d56fc693b524f8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.gif
// module id = 1941
// module chunks = 2